import { useGlobalStateStore } from "../../stores/store";
import Popover from "../filterComponents/Popover";
import { useState } from "react";

// MarketsCheckbox component
// This component renders a checkbox for a given filter
function MarketsCheckbox({ image, title, name, className, inputdisabled }) {
  const store = useGlobalStateStore();
  const selectedChecbox = store.filter.markets[name];

  const onChange = (e) => {
    const newValue = e.target.checked;
    store.setMarketFilter(name, newValue);
  };

  // store.setMarketFilter(name, selectedChecbox);

  return (
    <>
    
      <div className="markets__item">
        <div className="markets-item__title-row">
          {image}
          <span>{title}</span>
          <div className={`custom-checkbox ${className}`}>
            <input
              type="checkbox"
              name={name}
              id={name}
              checked={selectedChecbox}
              onChange={onChange}
              
            />
            <label htmlFor={name}></label>
            <Popover />
          </div>
        </div>
      </div>
    </>
  );
}

export default MarketsCheckbox;
